import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { thinkingPluginKey } from '../pm-plugins/thinking-plugin';

import type { StopThinkingAction } from './types';

export const stopThinkingAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => StopThinkingAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) => (): boolean => {
		return (
			api?.core?.actions.execute(({ tr }) => {
				tr.setMeta(thinkingPluginKey, {
					status: 'idle',
				});
				return tr;
			}) || false
		);
	};
